import { getColorTitle } from 'components/ColorPicker2/utils';
import { ThemeSettings } from '../../@types/ThemeSettings';

export const vedaFontToShopifyFieldId = (font: ThemeSettings['cssVariables']['fonts'][number]) => {
  return getColorTitle(font.name)
    .toLowerCase()
    .replace(/\s/g, '_');
};
